/* eslint-disable react-hooks/exhaustive-deps */
import { Button } from "@blueprintjs/core"
import { CSSProperties, useEffect, useState } from "react"
import { DIALOG_SIZE, WINDOW_WIDTH } from "src/libs/interfaces/layouts"
import addCSSClass from "src/libs/layout-app/utils/addCSSClass"
import removeCSSClass from "src/libs/layout-app/utils/removeCSSClass"
import FieldInput, { SCALAR_TYPES } from "src/libs/scalars"
import { ScalableDialog, showToast } from "src/libs/useful"
import { __ } from "src/libs/utilities"
import useScreenSize from "src/modules/pe-basic-module/hooks/useScreenSize"
import { actions } from "src/modules/pe-landing-module/data/actions"
import { GET_FB_GOODS_ACTION } from "src/modules/pe-landing-module/data/actionTypes"
import { FBGoodsContent, ILandingCategory } from "src/modules/pe-landing-module/data/interfaces"
import useCategory from "src/modules/pe-landing-module/hooks/useCategory"
import usePosition from "src/modules/pe-landing-module/hooks/usePosition"
import parseCSV from "../primitive/fb-goods/parseCSV"
import { IPrimitiveProps } from "../section/Primitive"

/* Protopia Ecosystem component */ 
export interface ICategoriesFilterProps extends IPrimitiveProps {
    onFilter: (cat: any, item: any) => void
}
const CategoriesFilter = (props: ICategoriesFilterProps): JSX.Element => { 
    const {position} = usePosition( props.primitive || {position: {}} )
    const primitive: FBGoodsContent = ( { ...props.primitive || {}, ...position.data } ) as FBGoodsContent  
    const [thread, setThread] = useState<string[]>([])
    const [data, setData] = useState<any[]>([])
    const [categories, setCategories] = useState<any[]>([])
    const style: CSSProperties = {
        color: primitive.style?.color,
        fontSize: primitive.style?.fontSize
    }
    useEffect(() => { 
        if(!!primitive.src) {
            actions(
                GET_FB_GOODS_ACTION,
                {
                    src: primitive.src
                }
            )
            .then(
                resp => {
                    const {thread, data, categories} = parseCSV(resp)
                    setThread(thread)                 
                    setData(data)                 
                    setCategories(categories)               
                },
                err => {
                    showToast({
                        message: err.toString()
                    })
                }
            )
        }
    }, [])
    useEffect(() => {
        addCSSClass(
            `landing-fb-goods-${ primitive.id }`,
            ` .landing-fb-goods-${ primitive.id } {
                position: relative;
                width:100%; 
                ${ position.opacity ? `opacity:${ position.opacity };` : ``}
                ${ `transform: scale(${ position.scale || 1 }) rotate(${ position.rotate || 0 }deg);` }
            }`
        )
        return () => removeCSSClass(`landing-fb-goods-${ primitive.id }`)
    },[ position ])
    
    const onFilter = (cat: any, item: any) => {
        props.onFilter(cat, item)
    }
    return !!primitive.src
        ?
        <div className={`fb-goods landing-fb-goods-${primitive.id}`} >  
            {
                categories.map(cat => {
                    return <CategoryFilter category={cat} onFilter={( item: any ) => onFilter(cat, item) } key={cat.name} />
                })
            }
        </div>
        :
        <></> 
}
export default CategoriesFilter

interface ICategoryFilterProps {
    category: any
    onFilter: ( item: any) => void
}
const CategoryFilter = (props: ICategoryFilterProps) => { 
    const sizses = useScreenSize()
    return sizses.width > WINDOW_WIDTH.TABLET 
        ?
        <CategoryFilterScreen {...props} />
        :
        <CategoryFilterMobile {...props} />
}

const CategoryFilterScreen = (props: ICategoryFilterProps) => {  
    const landingCategory : ILandingCategory | undefined = useCategory( props.category.name )
    const [item, setItem] = useState(null)
    useEffect(() => {
        addCSSClass(
            `cat-tag-${ props.category.name }`, 
            `.cat-tag-${ props.category.name } {
                background-color: ${ landingCategory?.color };
            }`
        )
        return () => removeCSSClass(`cat-tag-${ props.category.name }`)
    }, [])
    const onChange=(value: any, field: string, dop: any) => {
        setItem(value)
        props.onFilter(value)
    }
    return <div className="w-100">
        <div className="w-100 mb-1">{props.category.name}</div>
        <FieldInput
            type={ SCALAR_TYPES.TAGS } 
            multiple
            editable
            value={item}
            values={props.category.items.map((item: string) => ({
                _id: item, title: item, color: landingCategory?.color
            }))}
            onChange={onChange}
            elementClassName={`small py-0 px-3 cat-tag-${props.category.name}`}
            elementClassName2="small"
            notClear 
        />
    </div>
}

const CategoryFilterMobile = (props: ICategoryFilterProps) => { 
    const landingCategory : ILandingCategory | undefined = useCategory(props.category.name)
    const [item, setItem] = useState(null)
    const [isOpen, setIsOpen] = useState<boolean>(false)
    const onChange=(value: any, field: string, dop: any) => {
        setItem(value)
    }
    const onOpen = () => {
        setIsOpen(!isOpen)
    }
    const onFilter = () => {
        setIsOpen(false)
        props.onFilter( (item || []) )
    }
    return <div className="w-100 maxw-300">
        <Button variant="outlined" fill className=" mb-1" onClick={onOpen}>
            <div>
                {props.category.name}
            </div>
            <div className="flex-centered flex-wrap w-100">
                { (item || []).map(f => <div className="small opacity_5 mx-1">{ f }</div> ) }
            </div>
        </Button>
        
        <ScalableDialog
            isOpen={isOpen}
            onClose={onOpen}
            dialogSize={DIALOG_SIZE.LARGE}
            hideClose={false}
        >
            <div className="p-5">
                <FieldInput
                    type={ SCALAR_TYPES.TAGS } 
                    multiple
                    editable
                    value={item}
                    values={props.category.items.map((item: string) => ({
                        _id: item, title: item, color: landingCategory?.color
                    }))}
                    onChange={onChange}
                    elementClassName="small py-0 px-2"
                    elementClassName2="small"
                    notClear 
                />
                <div className="py-4">
                    <Button size="large" onClick={onFilter}>
                        {__("Filter")}
                    </Button>
                </div>
            </div>
            
        </ScalableDialog> 
    </div>
}